module.exports = __webpack_public_path__ + "static/assets/44f8fac4f30627584b76a2ab8ac24547.svg";